import { useState } from 'react'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col
} from 'reactstrap'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import '../css/di.css' // We'll need to add custom CSS

// Import your components
import CreateDi from './CreateDI'
import ViewDi from './ViewDi'
import PageHeader from './utils/PageHeader'
import ViewPackList from './ViewPackList'

const Di = () => {
  const [activeTab, setActiveTab] = useState('1')
  const userDetails = useSelector(store => store.user)

  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <div className='di-container'>
      <PageHeader
        pageName='DELIVERY INSTRUCTION'
        breadcrump1='Home'
        breadcrump2='Delivery Instruction'
        link='/dashboard'
      />

      <div className='p-3'>
        <div className='modern-tabs-wrapper'>
          <div className='modern-tabs-container'>
            <Nav className='modern-nav-tabs' tabs>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '1'
                  })}
                  onClick={() => toggle('1')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>
                      {userDetails?.role === 'commercial_manager' ? '👁️' : '📝'}
                    </span>
                    <span className='tab-text'>
                      {userDetails?.role === 'commercial_manager'
                        ? 'View SO'
                        : 'Create DI'}
                    </span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '2'
                  })}
                  onClick={() => toggle('2')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>👁️</span>
                    <span className='tab-text'>View DI</span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '3'
                  })}
                  onClick={() => toggle('3')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>👁️</span>
                    <span className='tab-text'>View Pack List</span>
                  </div>
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        <TabContent activeTab={activeTab} className='modern-tab-content'>
          <TabPane tabId='1' className='fade-in'>
            <Row>
              <Col>
                <CreateDi />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='2' className='fade-in'>
            <Row>
              <Col>
                <ViewDi />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='3' className='fade-in'>
            <Row>
              <Col>
                <ViewPackList />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    </div>
  )
}

export default Di
